import type { components } from '@connected/api-client/api.generated';

/** Inspection kinds that use interval questions */
export const INTERVAL_QUESTION_INSPECTION_KINDS: components['schemas']['ElectricalInspectionKind'][] = ['Scope8', 'Nen1010', 'Nen3140'];

export type CompletionFormValues = {
    intervalQuestions: {
        determineInspectionIntervalAge: components['schemas']['ElectricalInspectionDetermineIntervalKind'] | null;
        determineInspectionIntervalQuality: components['schemas']['ElectricalInspectionDetermineIntervalKind'] | null;
        determineInspectionIntervalEnvironment: components['schemas']['ElectricalInspectionDetermineIntervalKind'] | null;
        determineInspectionIntervalUsers: components['schemas']['ElectricalInspectionDetermineIntervalKind'] | null;
        determineInspectionIntervalSupervision: components['schemas']['ElectricalInspectionDetermineIntervalKind'] | null;
    };
    scopeInspection: { sciosInspectionCode: string };
    reports: {
        inspectionKind: components['schemas']['ElectricalInspectionKind'];
        intervalDeterminedByKind: components['schemas']['ElectricalInspectionIntervalDeterminedByKind'] | null;
        nextInspectionInYearCount: number | null;
        sciosInspectionCode: string;
        includeRepairStatement: boolean | null;
        isPerformedAccordingToInspectionPlan: boolean | null;
        performedAccordingToInspectionPlanRemark: string | null;
        isFinalVerdictPassed: boolean | null;
    }[];
    // Shared fields for single inspection (when reports.length === 1 or not used)
    nextInspectionInYearCount: number | null;
    intervalDeterminedByKind: components['schemas']['ElectricalInspectionIntervalDeterminedByKind'] | null;
    includeRepairStatement: boolean | null;
    isPerformedAccordingToInspectionPlan: boolean | null;
    performedAccordingToInspectionPlanRemark: string | null;
    isFinalVerdictPassed: boolean | null;
};

export const defaultCompletionFormValues: CompletionFormValues = {
    includeRepairStatement: null,
    intervalDeterminedByKind: null,
    intervalQuestions: {
        determineInspectionIntervalAge: null,
        determineInspectionIntervalEnvironment: null,
        determineInspectionIntervalQuality: null,
        determineInspectionIntervalSupervision: null,
        determineInspectionIntervalUsers: null,
    },
    isFinalVerdictPassed: null,
    isPerformedAccordingToInspectionPlan: null,
    performedAccordingToInspectionPlanRemark: null,
    nextInspectionInYearCount: null,
    reports: [],
    scopeInspection: { sciosInspectionCode: '' },
};
